import { useState } from 'react'
import { Card } from '@/components/ui/Card'
import { Button } from '@/components/ui/Button'
import { ShoppingBag, ExternalLink, Loader2 } from 'lucide-react'

export function ShopAccessButton() {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleAccessShop = async () => {
    setLoading(true)
    setError(null)

    try {
      const response = await fetch('/boutique/access', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
        }
      })

      const data = await response.json()

      if (data.url) {
        window.open(data.url, '_blank')
      } else if (data.error) {
        setError(data.error)
      }
    } catch {
      setError('Une erreur est survenue. Veuillez réessayer.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Card>
      <div className="text-center space-y-4">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-tessan-cream rounded-full">
          <ShoppingBag className="text-tessan-green" size={32} />
        </div>

        <div>
          <h2 className="text-xl font-semibold text-gray-900 mb-2">
            Accéder à ma boutique
          </h2>
          <p className="text-gray-600 text-sm max-w-md mx-auto">
            Parcourez notre catalogue et utilisez vos crédits pour commander des produits exclusifs.
          </p>
        </div>

        {error && (
          <div className="bg-red-50 text-red-700 p-3 rounded-lg text-sm">
            {error}
          </div>
        )}

        <Button
          onClick={handleAccessShop}
          disabled={loading}
          size="lg"
          className="bg-tessan-green hover:bg-tessan-green/90"
        >
          {loading ? (
            <>
              <Loader2 size={18} className="mr-2 animate-spin" />
              Chargement...
            </>
          ) : (
            <>
              Ouvrir la boutique
              <ExternalLink size={18} className="ml-2" />
            </>
          )}
        </Button>

        <p className="text-xs text-gray-400">
          La boutique s'ouvrira dans un nouvel onglet.
        </p>
      </div>
    </Card>
  )
}
